import { CreatePlanDataTypes } from '../OperationalPlanner.types'
import { HorizonInput } from './HorizonInput'

interface PlanHorizonInputsProps {
  createPlanDataObject: CreatePlanDataTypes
  createPlanData: CreatePlanDataTypes
  dispatch: React.Dispatch<any>
  isPlanCreating: boolean
  horizonsSelectionModeState: {
    planHorizon: string
    constrainingHorizon: string
  }
  setHorizonsSelectionModeState: (state: any) => void
  horizonSelectionMode: {
    weeks: string
    date: string
  }
  selectedTemplateKey: string | null
  setIsSelectedVariantEdited: (edited: boolean) => void
}

export const PlanHorizonInputs = (props: PlanHorizonInputsProps) => {
  return (
    <HorizonInput
      horizonType="plan"
      label="Plan horizon"
      calendarLabel="P horizon"
      {...props}
    />
  )
}
